































































import SubmitButton from "@/components/basic/buttons/SubmitButton.vue";
import Field from "@/components/basic/fields/Field.vue";
import Vue from "vue";
import { mapState } from "vuex";
import { SET_PROGRESS } from "@/constants/mutation-types";

export default Vue.extend({
  name: "Login",
  data() {
    return {
      isClicked: false,
      message: "",
      formData: {
        loginEmail: "",
        loginPassword: "",
      },
      TRANSLATION_KEY: "steps.Login",
    };
  },
  mounted() {
    this.$store.commit(SET_PROGRESS, 5);
  },
  methods: {
    login(): void {
      this.isClicked = true;

      if (!window.localStorage.getItem(KeyWords.IS_RETURNING)) {
        window.localStorage.setItem(KeyWords.IS_RETURNING, "true");
      }
    }
  },
  computed: {
    ...mapState({
      isEmail: (state: any) => state.formData.loginEmail,
      messageInfo: (state: any) => state.formData.message,
    }),
  },
  components: {
    Field,
    SubmitButton,
  },
});

enum KeyWords {
  IS_RETURNING = "isReturning",
}
